<script lang="ts">
  import BaseConditionalWrapper from "./baseConditionalWrapper.vue";
  import IRepo from "../../interfaces/repo";
  import ObjectModelConditionalRuleSet from "../../models/objectModels/objectModelConditionalRuleSet";
  import IConditionalRuleContainer from "../../models/conditionalRules/conditionalRuleContainer";
  import {ConditionalFieldDefinition} from "../../models/conditionalRules/conditionalFieldDefinition";

  export default BaseConditionalWrapper.extend({
    props: {
      fieldDefinition: Object as () => ConditionalFieldDefinition,
      parent: Object as () => IConditionalRuleContainer,
      ruleSetRepo: {
        type: Object as () => IRepo<ObjectModelConditionalRuleSet>,
        default: () => ObjectModelConditionalRuleSet.repo
      },
      disabled: Boolean,
      hasOtherwise: {
        type: Boolean,
        default: true
      },
      canAddRule: {
        type: Boolean,
        default: true
      },
    }
  });
</script>